import React, { useMemo, useState , useContext, useEffect} from 'react'
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Button,
  CardHeader,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "../../components/common/Breadcrumb";
import ProductList from './ProductList';
import OpenPopUp from './OpenPopUp'
import { AuthContext } from "../../contexts/AuthContext";
import { useAppSettings } from '../../contexts/AppSettingsContext';
import PaginationComponent from "../../components/common/Pagination";
import { getAllCertificatedProductsApi, getAllCertificationsApi , getAllProductsApi, handleAddCertificateApi, handleAddAssignedProductCertificateApi, getProductRelateCertificationDetailsApi} from "../../api/productCertification"
function Index() {
  const { appSettings } = useAppSettings();
  const itemsPerPage = process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE;  
  const appName = appSettings?.title ||process.env.REACT_APP_APP_NAME;
  const { authToken } = useContext(AuthContext);
  const [modal, setModal] = useState(false);
  const [mode, setMode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [certifications, setCertifications] =  useState([]);
  const [certificatedProducts, setAllCertificatedProducts] = useState([]);
  const [selectedCertificates, setSelectedCertificates] =  useState([]);
  const [products, setAllProducts] = useState([]);
  const [singleProductDetails, setSingleProductDetails] =  useState({});
  const [selectedProducts , setSelectedProducts] = useState([])
  const [isEditAction, setIsEditAction] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);
 

  useEffect(() => {
    fetchCertifications()
    fetchAllProducts()
  }, [authToken]);

  useEffect(() => {
    if(authToken){
      fetchCertificatedProducts();
    }
  }, [authToken, currentPage]);

  const singleProductData = useMemo(()=>{
        return singleProductDetails
  },[singleProductDetails])


  useEffect(()=>{
    if(Object.keys(singleProductData).length ==0){
      setIsEditAction(false);
      return
    } 
    setIsEditAction(true);

    let formattedSelectedCertificateData = {label : singleProductData?.certifications?.name, value : singleProductData?.certifications?.id}
    let formattedSelectedProductData = {label : singleProductData?.product_name, value : singleProductData?.id}

    
    assignCertificate.setFieldValue('start_date',singleProductData?.certifications?.start_date)
    assignCertificate.setFieldValue('end_date',singleProductData?.certifications?.expiry_date)

    setSelectedCertificates(formattedSelectedCertificateData)

    setSelectedProducts(formattedSelectedProductData)
  },[singleProductData])

  // Function for fetch all certificated products
  async function fetchCertificatedProducts() {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllCertificatedProductsApi(authToken, currentPage, itemsPerPage);
      const responseData  =  response?.data
      if (response?.code == 200) {
        setAllCertificatedProducts(responseData?.products);
        setTotalPages(Math.ceil((response?.totalCount || 1) / itemsPerPage));

      }
    } catch (error) {}
  }

  // Function for fetch certification
  async function fetchCertifications() {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllCertificationsApi(authToken);
      if (response?.code == 200) {
        setCertifications(response.data);
      }
    } catch (error) {}
  }

  async function fetchProductRelateCertificationDetails(productId){
    try{
      let response = await getProductRelateCertificationDetailsApi(authToken,productId);
      if (response?.code == 200) {
        setSingleProductDetails(response.data || []);
      }
      setMode("ASSIGN_CERTIFICATE");
      handleShow()
    }catch(error){
      console.log("error",error.message);
      
    }
  }

  // Function for fetch all products
  async function fetchAllProducts() {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllProductsApi(authToken);
      if (response?.code == 200) {
        setAllProducts(response.data);
      }
    } catch (error) {}
  }

  const formattedCertificateData =  useMemo(()=>{
      if(!Array.isArray(certifications)){
        return []
      }
      return certifications?.map((item)=>({ value : item.id, label : item?.name}))
  },[certifications])

  const formattedProductsData =  useMemo(()=>{
    return products?.map((item)=>({ value : item.id, label : item?.name}))
  },[products])

  const openModal = (type) => {
    if(type == 'ASSIGN_CERTIFICATE'){
      setSingleProductDetails({})
    }
    setMode(type);
    handleShow();
  };
  // Function handle open & close modal
  const handleShow = () => {
    setModal(!modal);
    if (!modal) {
      // # Reset form to initial values when modal is closed
      certificate.resetForm();
      assignCertificate.resetForm();
      setErrorMessage("");
      setSuccessMessage("");
      setSelectedCertificates([])
      setSelectedProducts([])
    }
  };

  const certificate =  useFormik({
      initialValues : {
        certificate_id : '',
        name  : '',
      },
      validationSchema: Yup.object({
        certificate_id : Yup.string().matches(/^\S+$/, "Space not allowed.")
      }),
      onSubmit : (values) =>{
        console.log("values", values);
        handleAddCertificate(values)
      }
  })


  
  const assignCertificate =  useFormik({
    initialValues : {
      certificate_id : '',
      product_id  : '',
      certification_file : '',
      start_date : ''  ,
      end_date :  '',
    },
    validationSchema: Yup.object({
      // product_id : Yup.string().required('Choose product'),
      // saber_fee : Yup.string().required('Saber fee is required.'),
      // saso_fee : Yup.string().required('Saso fee is required.')

    }),
    onSubmit : (values) =>{

      if (Object.keys(selectedCertificates)?.length === 0) {
        setErrorMessage("Select certificates");
        return;
      }

      
      if ( Object.keys(selectedProducts).length === 0) {
        setErrorMessage("Choose product");
        return;
      }
   
      setErrorMessage("");
    
      values.certificate_id = selectedCertificates.value
      values.product_id = selectedProducts?.value

      // This flag for identification for edit & assign functionality 
      let FLAG = true
      if(Object.keys(singleProductData).length !==0){
        FLAG= false
        values.product_id = singleProductData.product_id || ''
      }

      values.flag = FLAG
      console.log("values->>>",values);
      handleAddAssignProductCertificate(values)
    }
  })

  

async function handleAddAssignProductCertificate(values) {
  try{
    if(!authToken){
      throw new Error('Token not found')
    }
    let response = await handleAddAssignedProductCertificateApi(values, authToken);
    
    if (response?.code == 200) {
      setErrorMessage("");
      setSuccessMessage(response.message);
      fetchCertificatedProducts(authToken);
      setModal(false);
    } else {
      setSuccessMessage("");
      setErrorMessage(response?.message || "");
    }
  }catch(error){
    console.log("error", error.message);
    setSuccessMessage("");
    setErrorMessage("Something went wrong");
      
  }
}
  async function handleAddCertificate(values) {
    try{
      if(!authToken){
        throw new Error('Token not found')
      }
      let response = await handleAddCertificateApi(values, authToken);
      if (response?.code == 200) {
        setErrorMessage("");
        setSuccessMessage(response.message);
        fetchCertifications(authToken);
        setModal(false);
      } else {
        setSuccessMessage("");
        setErrorMessage(response?.message || "");
      }
    }catch(error){
      console.log("error", error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
        
    }
  }

  // #Props
  const productListProps = {
    certificatedProducts,
    fetchProductRelateCertificationDetails
  }
  const openPopUpPropsObj= {
    modal,
    handleShow,
    mode,
    certificate,
    errorMessage, 
    successMessage,
    formattedCertificateData,
    selectedCertificates,
    setSelectedCertificates,
    formattedProductsData,
    assignCertificate,
    selectedProducts ,
    setSelectedProducts,
    isEditAction
  }
  return (
    <div className="page-content">
       <Container fluid={true}>
          <Breadcrumbs title={appName} breadcrumbItem="Product Certification" />
          <Row>
            <Col lg={12}>
              <Card >
                <CardHeader tag="h5" className="p-1 d-flex justify-content-between">
                  <Button color="success"
                   onClick={()=>{openModal('ADD_CERTIFICATE')}}
                   >
                    Add Certification
                  </Button>
                  <Button color="success"
                    onClick={()=>{openModal('ASSIGN_CERTIFICATE')}}
                   >
                    Assign Certification
                  </Button>
                </CardHeader>
                <OpenPopUp
                  {...openPopUpPropsObj}
                />
                <CardBody className='p-5'>
                  <ProductList
                      {...productListProps}
                  />
                </CardBody>
                <div  className=" d-flex justify-content-end">
                  <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
                </div>
              </Card>
            </Col>
          </Row>
       </Container>
    </div>
  )
}

export default Index
